import { Card } from "../components/Card";
import { Button } from "../components/Button";
import { FaLaptopCode, FaMobileAlt, FaShoppingCart, FaUsers, FaServer, FaCogs } from "react-icons/fa";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const services = [
  {
    title: "Static Website Development",
    icon: <FaLaptopCode className="text-5xl text-sky-400" />,
    description: "Perfect for small businesses, static websites are cost-effective, fast-loading, and easy to maintain. Our team crafts aesthetically appealing, mobile-responsive static websites that effectively showcase your brand and services."
  },
  {
    title: "Dynamic Website Development",
    icon: <FaCogs className="text-5xl text-sky-400" />,
    description: "Ideal for businesses requiring frequent updates and interactive features. We build dynamic websites using modern frameworks like React, Angular, and backend technologies such as PHP, Node.js, and Ruby on Rails."
  },
  {
    title: "E-commerce Website Development",
    icon: <FaShoppingCart className="text-5xl text-sky-400" />,
    description: "Take your online store to new heights with our secure, scalable, and feature-rich e-commerce solutions. We integrate secure payment gateways, inventory management, and personalized user experiences to maximize your sales and revenue."
  },
  {
    title: "Android App Development",
    icon: <FaMobileAlt className="text-5xl text-sky-400" />,
    description: "We develop high-performing Android applications optimized for various screen sizes and devices. Our team ensures a seamless user experience with intuitive navigation, high-speed performance, and strong security measures."
  },
  {
    title: "iOS App Development",
    icon: <FaMobileAlt className="text-5xl text-sky-400" />,
    description: "Our iOS applications are designed with Apple's strict guidelines in mind. We create sleek, user-friendly apps with enhanced functionality, intuitive UI, and superior performance, ensuring smooth interactions for your users."
  },
  {
    title: "CRM Consulting",
    icon: <FaUsers className="text-5xl text-sky-400" />,
    description: "We help you choose the best CRM software tailored to your business requirements. Whether it's Salesforce, HubSpot, or a custom solution, we guide you in selecting a system that enhances customer engagement and business growth."
  },
  {
    title: "CRM Implementation",
    icon: <FaUsers className="text-5xl text-sky-400" />,
    description: "Streamline your sales, marketing, and customer service processes with our CRM implementation services. We ensure smooth adoption, staff training, and integration with existing business tools."
  },
  {
    title: "CRM Integration",
    icon: <FaUsers className="text-5xl text-sky-400" />,
    description: "We seamlessly integrate your CRM system with third-party applications, ensuring efficient data flow across your business processes. Our solutions enhance collaboration, automation, and data-driven decision-making."
  }
];

export default function WebTechnology() {
  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-100 to-indigo-100 flex flex-col items-center p-4 sm:p-6 md:p-10">
      <motion.h1
        className="text-4xl sm:text-5xl font-extrabold text-gray-800 mb-4 sm:mb-6 text-center"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        Web Technology Solutions
      </motion.h1>
      <p className="text-gray-600 text-center max-w-lg sm:max-w-2xl mb-6 sm:mb-10 text-lg">
        At Infyst Technologies, we provide cutting-edge web and mobile development solutions to help businesses thrive in the digital space.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 w-full max-w-7xl">
        {services.map((service, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
          >
            <Card className="p-8 bg-white shadow-xl rounded-2xl text-center flex flex-col items-center transition-transform hover:scale-105 hover:shadow-2xl">
              {service.icon}
              <h3 className="text-xl sm:text-2xl font-bold mt-4 text-gray-800">{service.title}</h3>
              <p className="text-gray-500 mt-2 text-sm sm:text-base leading-relaxed">{service.description}</p>
            </Card>
          </motion.div>
        ))}
      </div>

      <div className="mt-16 text-center max-w-4xl  bg-white  p-10 rounded-2xl shadow-lg ">
        <h2 className="text-4xl font-bold mb-6 text-black drop-shadow-md">Why to Choose Us?</h2>
        <ul className="mt-6 text-gray-600 text-lg space-y-4 sm:space-y-5 list-none">
          <li className="flex items-center text-left justify-start">
            <span className="text-green-500 text-2xl mr-2">✔</span>
            Ongoing support and maintenance to ensure your online presence stays strong
          </li>
          <li className="flex items-center text-left justify-start">
            <span className="text-green-500 text-2xl mr-2">✔</span>
            Expert team with extensive experience in web and mobile app development
          </li>
          <li className="flex items-center text-left justify-start">
            <span className="text-green-500 text-2xl mr-2">✔</span>
            Customized solutions tailored to your unique business needs
          </li>
          <li className="flex items-center text-left justify-start">
            <span className="text-green-500 text-2xl mr-2">✔</span>
            Cutting-edge technologies and innovative approaches
          </li>
          <li className="flex items-center text-left justify-start">
            <span className="text-green-500 text-2xl mr-2">✔</span>
            Fast turnaround times and competitive pricing
          </li>

        </ul>
      </div>

      <motion.div
        className="mt-12 flex flex-col items-center text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >


        <div className="flex flex-col gap-4 items-center justify-center">
          <Link onClick={() => {
            window.scroll(0, 0)
          }} to="/contact" className="block text-center lg:text-left mt-2 lg:mt-0">
            <button className="bg-sky-500 text-white font-bold px-10 py-3 rounded w-full lg:w-auto">
              Get Started
            </button>
          </Link>
          <p className="text-gray-600 text-lg max-w-2xl mb-6 px-4">
            Ready to take your online presence to the next level? Contact us today to discuss your web technology needs and let's get started on creating a robust online presence for your business!
          </p>


        </div>
      </motion.div>

    </div>
  );
}
